import { blockHomeSlider } from "./block-home-slider";
import { blockGallery } from "./block-gallery";
import { blockContactMap } from "./block-contact-map";
import { blockCompanies } from "./block-companies";
import { menu } from "./menu";
import { popup } from "./popup";
import { animation } from "./animation";

/** Init */
$(function () {
  animation();
  menu();
  popup();
  blockHomeSlider();
  blockGallery();
  blockCompanies();
  blockContactMap();
});
